import React from "react";
import "./styles.css";
import "./Search.css";
import TodayDate from "./Date";
import Iconweather from "./Iconweather";
import Temperatura from "./Temperatura";

export default function Infoweather(props){
  return (  
<div className="row">
              <div className="col">
                <h1 className="city" id="city">
                {props.data.city}
                </h1>
                <TodayDate date={props.data.date} />               
              </div>

              <div className="col">
                <Temperatura celsius={props.data.temperature} />
                <p>
                  Wind <span id="wind">{props.data.wind}</span> km/h
                </p>
                <span id="description">{props.data.description} </span>
                <div>
                  Humidity: <span id="humidity">{props.data.humidity}</span>%
                </div>
                <p className="weather">
                <Iconweather code={props.data.icon} size={55} />
                </p>
              </div>
              </div>);
}
